import styled from 'foundations-theming/utils';
import { filterProps } from 'foundations-components/utils/filterProps';
import { useMapTokenPropsToCSS } from 'foundations-components/hooks/useMapTokenPropsToCSS';
import { jsx as _jsx } from "react/jsx-runtime";
export const makeSpacedComponent = (element, getAdditionalCssStyles) => {
  const SpacedContainer = styled(element)(({
    $cssStyles
  }) => {
    return $cssStyles;
  });
  return props => {
    const {
      tokenProps,
      domProps
    } = filterProps(props);
    const additionalCssStyles = getAdditionalCssStyles ? getAdditionalCssStyles(props) : {};
    const spaceCssStyles = useMapTokenPropsToCSS(tokenProps);
    return /*#__PURE__*/_jsx(SpacedContainer, Object.assign({
      $cssStyles: Object.assign({}, spaceCssStyles, additionalCssStyles)
    }, domProps, {
      children: props.children
    }));
  };
};
export const SpacedDiv = makeSpacedComponent('div');